<template>
  <div class="lg:flex px-4 mb-20 lg:mb-30">
    <div class="w-full lg:w-[651px] mr-14 mb-6 lg:mb-0">
      <div>
        <div class="text-title text__headline-4-xs--bold lg:text__headline-3-md--bold">
          {{ unsureChoice.title }}
        </div>
      </div>
      <div class="mt-4 lg:mt-6">
        <div class="text-body-1 text__body-2--md--regular" v-html="unsureChoice.description" />
      </div>
    </div>
    <div class="mx-auto flex justify-center">
      <img
        data-src="@images/public/how-it-work/unsure-choice.png"
        class="lazyload mx-auto w-full lg:w-auto lg:h-[345px]"
      >
    </div>
  </div>
</template>
<script>
import staticData from './static-data'

export default {
  name: 'UnsureChoice',
  data () {
    return {
      unsureChoice: staticData.component.UnsureChoice
    }
  }
}
</script>
